(function() {

    'use strict';

    angular.module('eclipseApp.myAccount').controller('billingEnhancementModalCtrl', ['$scope', '$rootScope', 'uteLocale', '$modalInstance', function($scope, $rootScope, uteLocale, $modalInstance) {

        console.log('billingEnhancementModalCtrl');

        $scope.billEnhanceLang = uteLocale.language;

    }]);

})();
